import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformanceFilterApplied.meta';

export type UseTrackCreativePerformanceFilterAppliedParams = {
  type: 'status' | 'campaign' | 'ad_set';
};

export const useTrackCreativePerformanceFilterApplied = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformanceFilterApplied = useCallback(
    (params: UseTrackCreativePerformanceFilterAppliedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreativePerformanceFilterApplied };
};
